import styled from 'styled-components'

import { TransparentIconButton } from '../../Button'
import { IconChevronRight } from '@ui/elements/Icon'

export const DatepickerNextNavButton = styled((props) => {
  return (
    <TransparentIconButton
      iconComponent={<IconChevronRight />}
      {...props}
      aria-label='Next'
    />
  )
})`
  position: absolute;
  top: ${(props) => props.theme.typography.pxToRem(18)};
  right: ${(props) => props.theme.typography.pxToRem(22)};
`
